import { render, staticRenderFns } from "./TechnicalTreasureAddLayer.vue?vue&type=template&id=4adbe4f6&scoped=true&"
import script from "./TechnicalTreasureAddLayer.vue?vue&type=script&lang=js&"
export * from "./TechnicalTreasureAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalTreasureAddLayer.vue?vue&type=style&index=0&id=4adbe4f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adbe4f6",
  null
  
)

export default component.exports